import Component from './WatchButton';
import Container from './WatchButton.container';

export default Container(Component);
